import React from 'react'
import { Row, Col } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import StoryCard from '../../components/Story/StoryCard.jsx'
import { processError } from '../../lib/lib'
import api from '../../api/api'
import PropTypes from 'prop-types'
import Cookies from 'universal-cookie'
const cookies = new Cookies()

class Story extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            story: [],
            page: 0,
            limit: 6,
            storyLoaded: false,
            dataLoaded: false,
        }
    }
    async getStory(page, limit, lang, accessToken) {
        api.getStory(page, limit, lang, accessToken)
            .then((res) => this.setState({ story: res }))
            .catch((e) => processError(e, this.props.history))
    }

    changePage(page) {
        this.setState({ page })
        const accessToken = cookies.get('accessToken')
        this.getStory(page, this.state.limit, this.props.i18n.language, accessToken)
    }

    componentWillMount() {
        const accessToken = cookies.get('accessToken')
        let arrPromise = [
            this.getStory(this.state.page, this.state.limit, this.props.i18n.language, accessToken).then(() => this.setState({ storyLoaded: true })),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        return (
            <div className="content news-bg position-relative">
                <Row className="w-100 mx-0">
                    <Col xs={12} md={12} className="px-0">
                        <div className="page-title">
                            <div className="float-left">
                                <h1 className="title news-dashboard xl-font-size">{t('story-story')}</h1>
                            </div>
                        </div>

                        <div className="col-xl-12">
                            <section>
                                <div className="content-body news-bg">
                                    {' '}
                                    <Row className="px-15">
                                        {
                                            this.state.storyLoaded ?
                                                this.state.story.map((story) => (
                                                    <StoryCard key={story.id}
                                                        image={story.image}
                                                        id={story.id}
                                                        title={story.title}
                                                        name={story.name}
                                                        desc={story.desc}
                                                        props={this.props}
                                                        date={story.createdAt}
                                                    />
                                                ))
                                                :
                                                <React.Fragment>
                                                    <StoryCard skeleton={true} />
                                                    <StoryCard skeleton={true} />
                                                    <StoryCard skeleton={true} />
                                                </React.Fragment>
                                        }
                                    </Row>
                                </div>
                            </section>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

Story.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    history: PropTypes.object,
}

export default withTranslation()(Story)



// WEBPACK FOOTER //
// ./src/views/Story/Story.jsx